import { addDisplayName, addProps, flowMax } from 'ad-hok'
import { FC } from 'react'
import { createUseStyles } from 'react-jss'
import { Trans } from 'react-i18next'
import cx from 'classnames'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'
import { sansSerifFontFamily, serifFontFamily } from 'utils/styles'

const useStyles = createUseStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginLeft: 28,
    marginRight: 28,
  },
  title: {
    fontFamily: serifFontFamily,
    fontWeight: 400,
    fontSize: 22,
    lineHeight: '140%',
    color: 'rgba(255, 255, 255, 0.88)',
    marginBottom: 32,
  },
  definition: {
    marginLeft: 4,
    marginRight: 4,
    maxWidth: 283,
    fontFamily: sansSerifFontFamily,
    fontWeight: 500,
    fontSize: 14,
    lineHeight: '160%',
    color: 'rgba(255, 255, 255, 0.88)',
  },
  numbers: {
    fontWeight: 600,
    color: '#CDAA7E',
  },
})

interface Props {
  className?: string
}

export const RodeoDescription: FC<Props> = flowMax(
  addDisplayName('RodeoDescription'),
  addProps(() => ({
    classes: useStyles(),
  })),
  addTranslationHelpers,
  ({ classes, className, t }) => (
    <div className={cx(classes.container, className)}>
      <div className={classes.title}>{t('menu.description.title')}</div>
      <div className={classes.definition}>
        <Trans t={t} i18nKey="menu.description.definition">
          <span className={classes.numbers} />
          <span className={classes.numbers} />
        </Trans>
      </div>
    </div>
  )
)
